import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/search/actionTypes';
import { changeLocation } from './utils';

export default function* listenChangeLocation() {
  yield takeEvery(actionTypes.CHANGE_LOCATION, changeLocation);
}
